module.exports = __webpack_public_path__ + "static/media/cert.e5f361af.svg";